var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mpe-grid container w-100" },
    [
      !_vm.isCalendarView
        ? _c(
            "div",
            { staticClass: "row" },
            [
              _vm._l(_vm.getDisplayMpeList, function(mpe, i) {
                return _c(
                  "div",
                  { key: "" + i + mpe.id, class: _vm.getColumns },
                  [
                    _c("grid-item", {
                      attrs: {
                        dataLoading: _vm.isDataLoading(mpe.id),
                        item: mpe,
                        displayType: _vm.listStyle,
                        variant: _vm.variant
                      },
                      on: {
                        editMpe: _vm.editMpe,
                        removeMpe: _vm.removeMpe,
                        duplicate: _vm.duplicate
                      }
                    })
                  ],
                  1
                )
              }),
              _vm._v(" "),
              !_vm.getDisplayMpeList.length
                ? _c("div", [
                    _c("h5", { staticClass: "m-3 text-center" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("Campaigns.filterNoResults")) +
                          "\n      "
                      )
                    ])
                  ])
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isCalendarView
        ? _c("campaign-calendar", {
            ref: "mpeCalendar",
            attrs: {
              mpes: _vm.getDisplayMpeList,
              calendarStyle: _vm.getCalendarStyle,
              campaignPreviewItems: _vm.campaignPreviewItems,
              useCalendarNavigation: _vm.useCalendarNavigation,
              removing: _vm.removing,
              validRange: _vm.validRange,
              buttonText: _vm.getButtonText,
              viewedMonth: _vm.viewedMonth,
              variant: _vm.variant
            },
            on: {
              editMpe: _vm.editMpe,
              setSchedule: _vm.setSchedule,
              removeMpe: _vm.removeMpe,
              duplicate: _vm.duplicate,
              changeDate: _vm.changeDate
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-100fe89c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-100fe89c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/service/campaignManager/MpeGrid.vue
// module id = null
// module chunks = 